import React from 'react'
import { ExpandMore as ExpandMoreIcon, Launch as LaunchIcon } from '@mui/icons-material'
import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Button,
  Tooltip,
} from '@mui/material'
import { useAccordionStyles } from '../../style/lookup'
import { ResultTitle } from '../../style/result'

type Props = { apiData: any }

export const PdfProfiler = (props: Props) => {
  const { apiData } = props
  const accordionClasses: any = useAccordionStyles()

  const allData = apiData?.apiDataEntities ?? []
  const htmlData: any = allData.find((item: any) => item.from === 'pdf_report')?.data?.htmlReport
  const pdfLink: string | undefined =
    allData.find((item: any) => item.from === 'pdf_report')?.data?.pdfReport

  const [accordionOpen, setAccordionOpen] = React.useState<boolean>(true)

  const handleChangeAccordion = (_: React.SyntheticEvent, expanded: boolean) => {
    setAccordionOpen(expanded)
  }

  const handleOpenPdf = React.useCallback(() => {
    const url = (pdfLink ?? '').trim()
    if (!url) return
    const win = window.open(url, '_blank', 'noopener,noreferrer')
    if (!win) {
      console.warn('Popup was blocked by the browser.')
    }
  }, [pdfLink])

  return (
    <>
      <Stack direction="row" justifyContent="center" sx={{ mt: 1, mb: 1 }}>
        <Tooltip title={pdfLink ? 'Open PDF in a new tab' : 'Report is not ready'}>
          <span>
            <Button
              variant="contained"
              startIcon={<LaunchIcon />}
              onClick={handleOpenPdf}
              disabled={!pdfLink}
            >
              Open PDF
            </Button>
          </span>
        </Tooltip>
      </Stack>

      <Accordion
        classes={accordionClasses}
        square
        expanded={accordionOpen}
        onChange={handleChangeAccordion}
        sx={{ marginTop: '10px' }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack>
            <ResultTitle sx={{ marginTop: '10px' }}>Preview:</ResultTitle>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Divider
            sx={{
              margin: '-5px 0px 15px 0px',
              border: `0.1px solid rgba(46, 151, 213, 0.3)`,
            }}
          />
          {htmlData && (
            <Stack sx={{ backgroundColor: '#F0F2FA', overflowX: 'auto' }}>
              <div dangerouslySetInnerHTML={{ __html: htmlData }} />
            </Stack>
          )}
        </AccordionDetails>
      </Accordion>
    </>
  )
}
